/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MIMResultsPreviewExportFiltersDTO { 
    /**
     * Measured client identifier. Use the client ID returned by the authenticated context.
     */
    clientId: number;
    /**
     * Brand identifier within the client. Use this together with clientId when a request targets a specific brand.
     */
    brandId: number;
    /**
     * Conversion types to include in the export
     */
    conversionTypes: Array<string>;
    /**
     * Export period start date in ISO-8601 format
     */
    dateStart: string;
    /**
     * Export period end date in ISO-8601 format
     */
    dateStop: string;
    /**
     * Time-series resolution of the exported rows
     */
    timeSeriesResolution: MIMResultsPreviewExportFiltersDTO.TimeSeriesResolutionEnum;
    /**
     * Channels to include; omit or leave empty for all
     */
    channels?: Array<string>;
    /**
     * Segments to include; omit or leave empty for all
     */
    segments?: Array<string>;
    /**
     * Tactics to include; omit or leave empty for all
     */
    tactics?: Array<string>;
}
export namespace MIMResultsPreviewExportFiltersDTO {
    export type TimeSeriesResolutionEnum = 'day' | 'week' | 'week_0' | 'month' | 'quarter' | 'fullPeriod';
    export const TimeSeriesResolutionEnum = {
        Day: 'day' as TimeSeriesResolutionEnum,
        Week: 'week' as TimeSeriesResolutionEnum,
        Week0: 'week_0' as TimeSeriesResolutionEnum,
        Month: 'month' as TimeSeriesResolutionEnum,
        Quarter: 'quarter' as TimeSeriesResolutionEnum,
        FullPeriod: 'fullPeriod' as TimeSeriesResolutionEnum
    };
}


